import { useTranslation } from 'react-i18next'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatNumber } from '@/utils/format'
import type { ChartPoint } from '../api'
import { ChartTooltip } from './ChartTooltip'

export function ClassBarChart({ data }: { data: ChartPoint[] }) {
  const { t } = useTranslation('dashboard')
  const short = data.map((d) => ({ ...d, short: d.label.replace(/^Grade\s+/i, 'G') }))
  return (
    <div
      className="h-64"
      role="img"
      aria-label={t('Active students per class: {{list}}', {
        list: data.map((d) => `${d.label} ${d.value}`).join(', '),
      })}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={short} margin={{ top: 8, right: 4, left: -22, bottom: 0 }} barCategoryGap="28%">
          <CartesianGrid vertical={false} stroke="var(--line)" strokeDasharray="3 4" />
          <XAxis
            dataKey="short"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11, fill: 'var(--muted)' }}
            dy={6}
          />
          <YAxis
            allowDecimals={false}
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 11, fill: 'var(--muted)' }}
            width={40}
          />
          <Tooltip
            content={({ active, payload }) => (
              <ChartTooltip
                active={active}
                payload={payload as never}
                label={(payload[0]?.payload as ChartPoint | undefined)?.label}
                format={(v) => t('{{value}} students', { count: v, value: formatNumber(v) })}
              />
            )}
            cursor={{ fill: 'var(--surface-sunken)' }}
          />
          <Bar dataKey="value" fill="#4f46e5" radius={[4, 4, 0, 0]} maxBarSize={36} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
